export default __webpack_public_path__ + "static/6838-88c32b12d03b2485e58c11fa9afc79c7.jpg";